import { useCallback, useEffect, useState } from "react"
import { useHistory, useParams } from "react-router";

import { IBancoVanBancaria, IContasEPlanilhaResponse } from "../../interfaces";
import { IOrgao, IOrgaoManutencaoAtivacao, IOrgaoVinculado } from "../interfaces";
import { IUpdateCategoriasUsuario } from "../../SolicitacoesDeAtivacao/Gerenciar/Tabs/PermissoesUsuarios/interfaces";
import { IUpdateSistema } from "../../SolicitacoesDeAtivacao/Gerenciar/Tabs/IntegracaoComSistemaContabil/components/GerenciarSistemaContabil/interfaces";
import { ICreateOrgaoVinculado, IDeleteOrgaoVinculado, IUpdateOrgaoVinculado } from "../../SolicitacoesDeAtivacao/Gerenciar/Tabs/IntegracaoComSistemaContabil/components/OrgaosVinculadosStep/interfaces";
import { IAutorizacao, IConfiguracaoContabil, IContaSaldoDeContas, IFonteSaldoDeContas, IOrgaoAutorizacaoItem, IOrgaoComErro, ISistemaContabil, IUsuarioSolicitacao } from "../../SolicitacoesDeAtivacao/interfaces";
import { ICreateConfiguracaoSistemaContabil, IUpdateConfiguracaoSistemaContabil } from "../../SolicitacoesDeAtivacao/Gerenciar/Tabs/IntegracaoComSistemaContabil/components/ConfigurarSistemaContabil/interfaces";
import { IUpdateSistemaContabilIntegrado, IUpdateTipoEmpenhosERestos } from "../../SolicitacoesDeAtivacao/Gerenciar/Tabs/IntegracaoComSistemaContabil/components/interfaces";
import { ICreateConta, ICreateFonte, IDeleteConta, IDeleteFonte, IOrdenacaoCategoriaItem, IUpdateCategoriaFonte, IUpdateConta, IUpdateContasFontes, IUpdateDescricaoFonte, IUpdateFonteFavorita, IUpdateOrdenacaoFontes } from "../../SolicitacoesDeAtivacao/Gerenciar/Tabs/AlinhamentoDeContasEFontes/interfaces";

import { ICreateCredenciais, ICreateCredenciaisVan, ICreateIdAplicacao, IDeleteAutorizacao, IGetDocumentoVanSignedUrl, IUpdateCredenciais, IUpdateCredenciaisVan, IUpdateIdAplicacao, IUpdateNumeroRequerimentoVan } from "../../SolicitacoesDeAtivacao/Gerenciar/Tabs/IntegracaoComBancos/interfaces";

import OrgaoService from "../../../../services/http/services/SaldoDeContas/OrgaoService";
import FontesACadastrarService from "../../../../services/http/services/SaldoDeContas/FontesACadastrarService";
import ContasACadastrarService from "../../../../services/http/services/SaldoDeContas/ContasACadastrarService";

export default function useAdicionarOrgao() {
    let { id }: any = useParams();

    const [isLoadingOrgao, setIsLoadingOrgao] = useState(true);
    const [orgao, setOrgao] = useState<IOrgaoManutencaoAtivacao | null>(null);
    const [activeKeyTabs, setActiveKeyTabs] = useState<any>('integracao-contabil');

    const history = useHistory();

    const handleClickVoltar = useCallback((): void => {
        history.push("/orgaos");
    }, [history]);

    const onClickTab = useCallback((tab: string) => {
        setActiveKeyTabs(tab)
    }, []);

    const handleCreateOrgaoVinculado = useCallback(async (data: ICreateOrgaoVinculado): Promise<IOrgao | null> => {
        if (!orgao) {
            return null;
        }

        const createdOrgaoVinculado = await OrgaoService.createOrgaoVinculado({
            orgaoId: data.orgaoId,
            ...data.orgaoVinculado,
        });

        return {
            ...orgao,
            orgaosVinculados: [
                ...orgao.orgaosVinculados,
                createdOrgaoVinculado,
            ]
        };
    }, [orgao]);

    const handleUpdateOrgaoVinculado = useCallback(async (data: IUpdateOrgaoVinculado): Promise<IOrgao | null> => {
        if (!orgao) {
            return null;
        }

        const updatedOrgaoVinculado = await OrgaoService.updateOrgaoVinculado({
            orgaoId: data.orgaoId,
            orgaoVinculadoId: data.orgaoVinculadoId,
            ...data.orgaoVinculado,
        });

        const orgaosVinculados = [...orgao.orgaosVinculados];

        const orgaoVinculadoIndex = orgaosVinculados.findIndex((e) => e.id === updatedOrgaoVinculado.id);

        if (orgaoVinculadoIndex >= 0) {
            orgaosVinculados[orgaoVinculadoIndex] = updatedOrgaoVinculado;
        }

        return {
            ...orgao,
            orgaosVinculados,
        };
    }, [orgao]);

    const handleDeleteOrgaoVinculado = useCallback(async (data: IDeleteOrgaoVinculado): Promise<IOrgao | null> => {
        if (!orgao) {
            return null;
        }

        await OrgaoService.deleteOrgaoVinculado({
            orgaoId: data.orgaoId,
            orgaoVinculadoId: data.orgaoVinculadoId,
        });

        const orgaosVinculados = [...orgao.orgaosVinculados].filter((e) => e.id !== data.orgaoVinculadoId);

        return {
            ...orgao,
            orgaosVinculados,
        };
    }, [orgao]);

    const requestUpdateSistemaContabil = useCallback(async (data: IUpdateSistema): Promise<ISistemaContabil | null> => {
        if (!orgao) {
            return null;
        }

        const updatedSistemaContabil = await OrgaoService.updateSistemaContabil({
            orgaoId: orgao.id,
            sistemaContabilId: data.sistemaContabilId,
        });

        return updatedSistemaContabil;
    }, [orgao]);

    const handleUpdateOrgao = useCallback((updatedOrgao: IOrgao) => {
        setOrgao((prevState) => {
            if (!prevState) {
                return null
            }

            return {
                ...prevState,
                ...updatedOrgao
            }
        });
    }, []);

    const handleUpdateSistemaContabil = useCallback((updatedSistemaContabil: ISistemaContabil) => {
        setOrgao((prevState) => {
            if (!prevState) {
                return null
            }

            return {
                ...prevState,
                solicitacaoAtivacao: {
                    ...prevState.solicitacaoAtivacao,
                    sistemaContabil: updatedSistemaContabil,
                    sistemaContabilId: updatedSistemaContabil.id,
                }
            }
        });
    }, []);

    const handleCreateConfiguracaoSistemaContabil = useCallback(async (data: ICreateConfiguracaoSistemaContabil): Promise<IConfiguracaoContabil | null> => {
        if (!orgao) {
            return null;
        }

        const createdConfiguracaoContabil = await OrgaoService.createConfiguracaoSistemaContabil({
            orgaoId: orgao.id,
            configuracao: data.configuracao,
        });

        return createdConfiguracaoContabil;
    }, [orgao]);

    const handleUpdateConfiguracaoSistemaContabil = useCallback(async (data: IUpdateConfiguracaoSistemaContabil): Promise<IConfiguracaoContabil | null> => {
        if (!orgao) {
            return null;
        }

        const updatedConfiguracaoContabil = await OrgaoService.updateConfiguracaoSistemaContabil({
            orgaoId: orgao.id,
            configuracao: data.configuracao,
        });

        return updatedConfiguracaoContabil;
    }, [orgao]);

    const handleDeleteConfiguracaoSistemaContabil = useCallback(async (): Promise<void> => {
        if (!orgao) {
            return;
        }

        await OrgaoService.deleteConfiguracaoSistemaContabil(orgao.id);
    }, [orgao]);

    const handleConfiguracaoSistemaContabilChange = useCallback((configuracaoContabil: IConfiguracaoContabil | null) => {
        setOrgao((prevState) => {
            if (!prevState) {
                return null;
            }

            return {
                ...prevState,
                solicitacaoAtivacao: {
                    ...prevState.solicitacaoAtivacao,
                    configuracaoContabil,
                }
            }
        });
    }, []);

    const handleUpdateTipoEmpenhosERestos = useCallback(async (data: IUpdateTipoEmpenhosERestos): Promise<string> => {
        if (!orgao) {
            return data.tipo;
        }

        const updatedValue = await OrgaoService.updateTipoEmpenhosERestos({ orgaoId: orgao.id, tipo: data.tipo });

        return updatedValue;
    }, [orgao]);

    const handleTipoEmpenhosERestosChange = useCallback((value: string) => {
        setOrgao((prevState) => {
            if (!prevState) {
                return null;
            }

            return {
                ...prevState,
                solicitacaoAtivacao: {
                    ...prevState.solicitacaoAtivacao,
                    tipoEmpenhosERestos: value,
                }
            }
        });
    }, []);

    const handleUpdateSistemaContabilIntegrado = useCallback(async (data: IUpdateSistemaContabilIntegrado): Promise<boolean> => {
        if (!orgao) {
            return data.integrado;
        }

        const response = await OrgaoService.updateSistemaContabilIntegrado({
            orgaoId: orgao.id,
            integrado: data.integrado,
        });

        return response;
    }, [orgao]);

    const handleSistemaContabilIntegradoChange = useCallback((value: boolean) => {
        setOrgao((prevState) => {
            if (!prevState) {
                return null;
            }

            return {
                ...prevState,
                solicitacaoAtivacao: {
                    ...prevState.solicitacaoAtivacao,
                    empenhosERestos: value,
                }
            }
        });
    }, []);

    const handleGetOrdenacaoFontes = useCallback(async (): Promise<IOrdenacaoCategoriaItem[]> => {
        if (!orgao) {
            return [];
        }

        const ordenacaoFontesData = await OrgaoService.getOrdenacaoFontes({ orgaoId: orgao.id });

        return ordenacaoFontesData;
    }, [orgao]);

    const handleGetFontesOrfas = useCallback(async (): Promise<IOrdenacaoCategoriaItem[]> => {
        if (!orgao) {
            return [];
        }

        const fontesOrfasData = await OrgaoService.getFontesOrfas({ orgaoId: orgao.id });

        return fontesOrfasData;
    }, [orgao]);

    const handleUpdateFonteFavorita = useCallback(async (data: IUpdateFonteFavorita): Promise<void> => {
        if (!orgao) {
            return;
        }

        await OrgaoService.atualizarFonteFavorita({
            orgaoId: orgao.id,
            favorita: data.favorita,
            numeroFonte: data.numeroFonte,
        });
    }, [orgao]);

    const handleGetContasEPlanilha = useCallback(async (): Promise<IContasEPlanilhaResponse> => {
        if (!orgao) {
            return {
                contas: [],
                planilha: null,
            };
        }

        const contasEPlanilhaData = await OrgaoService.getContasEPlanilha({ orgaoId: orgao.id });

        return contasEPlanilhaData;
    }, [orgao]);

    const handleUpdateCategoriaFonte = useCallback(async (data: IUpdateCategoriaFonte): Promise<void> => {
        if (!orgao) {
            return;
        }

        await OrgaoService.updateCategoriaFonte({
            categoriaId: data.categoriaId,
            numero: data.numero,
            orgaoId: orgao.id,
        });
    }, [orgao]);

    const handleUpdateDescricaoFonte = useCallback(async (data: IUpdateDescricaoFonte): Promise<IFonteSaldoDeContas | null> => {
        if (!orgao) {
            return null;
        }

        if (data.isGroup) {
            const updatedFonte = await OrgaoService.updateDescricaoFonteConsolidada({
                descricao: data.descricao,
                numero: data.numero,
                orgaoId: orgao.id,
            });

            return updatedFonte;
        }

        const updatedFonte = await OrgaoService.updateDescricaoFonte({
            descricao: data.descricao,
            numero: data.numero,
            orgaoId: orgao.id,
        });

        return updatedFonte;
    }, [orgao]);

    const handleCreateFonte = useCallback(async (data: ICreateFonte): Promise<IFonteSaldoDeContas | null> => {
        if (!orgao) {
            return null;
        }

        const createdFonte = await FontesACadastrarService.createFonte({
            categoriaId: data.categoriaId,
            descricao: data.descricao,
            numero: data.numero,
            orgaoId: orgao.id,
        });

        return createdFonte;
    }, [orgao]);

    const handleUpdateConta = useCallback(async (data: IUpdateConta): Promise<IContaSaldoDeContas | null> => {
        if (!orgao) {
            return null;
        }

        const updatedContaResponse = await OrgaoService.updateConta({
            agencia: data.agencia,
            bancoId: data.bancoId,
            contaId: data.contaId,
            descricao: data.descricao,
            fonteIds: data.fonteIds,
            numero: data.numero,
            orgaoId: orgao.id,
            orgaoVinculadoId: data.orgaoVinculadoId,
        });

        return updatedContaResponse;
    }, [orgao]);

    const handleCreateConta = useCallback(async (data: ICreateConta): Promise<IContaSaldoDeContas | null> => {
        const createdContaResponse = await ContasACadastrarService.createConta({
            agencia: data.agencia,
            bancoId: data.bancoId,
            descricao: data.descricao,
            fonteIds: data.fonteIds,
            numero: data.numero,
            orgaoVinculadoId: data.orgaoVinculadoId,
        });

        return createdContaResponse;
    }, []);

    const handleDeleteConta = useCallback(async (data: IDeleteConta): Promise<void> => {
        if (!orgao) {
            return;
        }

        await OrgaoService.deleteConta({
            contaId: data.contaId,
            orgaoId: orgao.id,
        });
    }, [orgao]);

    const handleEncerrarConta = useCallback(async (contaId: number): Promise<void> => {
        await OrgaoService.encerrarConta(contaId);
    }, []);

    const handleDeleteFonte = useCallback(async (data: IDeleteFonte): Promise<void> => {
        if (!orgao) {
            return;
        }

        await OrgaoService.deleteFonte({
            orgaoId: orgao.id,
            fonteId: data.fonteId,
        });
    }, [orgao]);

    const handleUpdateContasFontes = useCallback(async (data: IUpdateContasFontes): Promise<IContaSaldoDeContas[]> => {
        if (!orgao) {
            return [];
        }

        const response = await OrgaoService.updateContasFontes({
            orgaoId: orgao.id,
            contaIds: data.contaIds,
            fonteIds: data.fonteIds,
        });

        return response;
    }, [orgao]);

    const handleGetAutorizacoesBancoDoBrasil = useCallback(async (): Promise<IOrgaoAutorizacaoItem[]> => {
        if (!orgao) {
            return [];
        }

        const response = await OrgaoService.getAutorizacoesBancoDoBrasil({ orgaoId: orgao.id });

        return response;
    }, [orgao]);

    const handleGetContasComErro = useCallback(async (): Promise<IOrgaoComErro[]> => {
        if (!orgao) {
            return [];
        }

        const response = await OrgaoService.getContasComErro({ orgaoId: orgao.id });

        return response;
    }, [orgao]);

    const handleGetContasInativas = useCallback(async (): Promise<IOrgaoComErro[]> => {
        if (!orgao) {
            return [];
        }

        const response = await OrgaoService.getContasInativas({ orgaoId: orgao.id });

        return response;
    }, [orgao]);

    const handleCreateIdAplicacao = useCallback(async (data: ICreateIdAplicacao): Promise<IAutorizacao | null> => {
        if (!orgao) {
            return null;
        }

        const createdIdAplicacaoResponse = await OrgaoService.createIdAplicacao({
            bbAplicacaoId: data.bbAplicacaoId,
            orgaoVinculadoId: data.orgaoVinculadoId,
            versaoApi: data.versaoApi,
            orgaoId: orgao.id,
        });

        return createdIdAplicacaoResponse;
    }, [orgao]);

    const handleUpdateIdAplicacao = useCallback(async (data: IUpdateIdAplicacao): Promise<IAutorizacao | null> => {
        if (!orgao) {
            return null;
        }

        const updatedIdAplicacaoResponse = await OrgaoService.updateIdAplicacao({
            bbAplicacaoId: data.bbAplicacaoId,
            autorizacaoBbId: data.autorizacaoBbId,
            versaoApi: data.versaoApi,
            orgaoId: orgao.id,
        });

        return updatedIdAplicacaoResponse;
    }, [orgao]);

    const handleCreateCredenciais = useCallback(async (data: ICreateCredenciais): Promise<IAutorizacao | null> => {
        if (!orgao) {
            return null;
        }

        const createdCredenciaisResponse = await OrgaoService.createCredenciais({
            appKey: data.appKey,
            autorizacaoBbId: data.autorizacaoBbId,
            basic: data.basic,
            clientId: data.clientId,
            clientSecret: data.clientSecret,
            orgaoId: orgao.id,
        });

        return createdCredenciaisResponse;
    }, [orgao]);

    const handleUpdateCredenciais = useCallback(async (data: IUpdateCredenciais): Promise<IAutorizacao | null> => {
        if (!orgao) {
            return null;
        }

        const updatedCredenciaisResponse = await OrgaoService.updateCredenciais({
            appKey: data.appKey,
            autorizacaoBbId: data.autorizacaoBbId,
            basic: data.basic,
            clientId: data.clientId,
            clientSecret: data.clientSecret,
            orgaoId: orgao.id,
        });

        return updatedCredenciaisResponse;
    }, [orgao]);

    const handleDeleteAutorizacao = useCallback(async (data: IDeleteAutorizacao): Promise<void> => {
        if (!orgao) {
            return;
        }

        await OrgaoService.deleteAutorizacao({
            autorizacaoId: data.autorizacaoId,
            orgaoId: orgao.id,
        });
    }, [orgao]);

    const handleGetBancosVanBancaria = useCallback(async (): Promise<IBancoVanBancaria[]> => {
        if (!orgao) {
            return [];
        }

        const response = await OrgaoService.getBancosVanBancaria({ orgaoId: orgao.id });

        return response;
    }, [orgao]);

    const handleUpdateNumeroRequerimentoVan = useCallback(async (data: IUpdateNumeroRequerimentoVan): Promise<IBancoVanBancaria | null> => {
        if (!orgao) {
            return null;
        }

        const response = await OrgaoService.updateNumeroRequerimento({
            orgaoId: orgao.id,
            autorizacaoId: data.autorizacaoId,
            numeroRequerimento: data.numeroRequerimento,
        });

        return response;
    }, [orgao]);

    const handleCreateCredenciaisVan = useCallback(async (data: ICreateCredenciaisVan): Promise<IBancoVanBancaria | null> => {
        if (!orgao) {
            return null;
        }

        const response = await OrgaoService.createCredenciaisVanBancaria({
            orgaoId: orgao.id,
            autorizacaoId: data.autorizacaoId,
            clientId: data.clientId,
            clientSecret: data.clientSecret,
        });

        return response;
    }, [orgao]);

    const handleUpdateCredenciaisVan = useCallback(async (data: IUpdateCredenciaisVan): Promise<IBancoVanBancaria | null> => {
        if (!orgao) {
            return null;
        }

        const response = await OrgaoService.updateCredenciaisVanBancaria({
            orgaoId: orgao.id,
            autorizacaoId: data.autorizacaoId,
            clientId: data.clientId,
            clientSecret: data.clientSecret,
        });

        return response;
    }, [orgao]);

    const handleGetDocumentoSignedUrlVan = useCallback(async (data: IGetDocumentoVanSignedUrl): Promise<{ url?: string; link?: string } | any> => {
        if (!orgao) {
            return null;
        }

        const response = await OrgaoService.getDocumentoVanBancariaSignedUrl({
            orgaoId: orgao.id,
            autorizacaoId: data.autorizacaoId,
            documentoId: data.documentoId,
        });

        return response;
    }, [orgao]);

    const handleGetUsuarios = useCallback(async (): Promise<IUsuarioSolicitacao[]> => {
        if (!orgao) {
            return [];
        }

        const response = await OrgaoService.getUsuarios({ orgaoId: orgao.id });

        return response;
    }, [orgao]);

    const handleUpdateCategoriasUsuario = useCallback(async (data: IUpdateCategoriasUsuario): Promise<IUsuarioSolicitacao | null> => {
        if (!orgao) {
            return null;
        }

        const response = await OrgaoService.updateCategoriasUsuario({
            categoriaIds: data.categoriaIds,
            usuarioId: data.usuarioId,
            orgaoId: orgao.id,
        });

        return response;
    }, [orgao]);

    const handleGetFontes = useCallback(async (): Promise<IFonteSaldoDeContas[] | null> => {
        if (!orgao) {
            return null;
        }

        const response = await OrgaoService.getFontes({ orgaoId: orgao.id });

        return response;
    }, [orgao]);

    const handleGetOrgaosVinculados = useCallback(async (): Promise<IOrgaoVinculado[] | null> => {
        if (!orgao) {
            return null;
        }

        const response = await OrgaoService.getOrgaosVinculadosByOrgaoId({ orgaoId: orgao.id });

        return response;
    }, [orgao]);

    const handleUpdateOrdenacaoFontes = useCallback(async (data: IUpdateOrdenacaoFontes): Promise<IOrdenacaoCategoriaItem | null> => {
        if (!orgao) {
            return null;
        }

        const response = await OrgaoService.atualizarOrdenacaoFontes({
            categoriaId: data.categoriaId,
            numerosFontes: data.numerosFontes,
            orgaoId: orgao.id,
        });

        return response;
    }, [orgao]);

    useEffect(() => {
        async function loadOrgao() {
            try {
                setIsLoadingOrgao(true);

                const orgaoData = await OrgaoService.getOrgaoById({ orgaoId: id });

                setOrgao(orgaoData);

                setIsLoadingOrgao(false);
            } catch (err) {
                setIsLoadingOrgao(false);
            }
        }

        loadOrgao();
    }, [id]);

    return {
        orgao,
        isLoadingOrgao,
        handleClickVoltar,
        activeKeyTabs,
        onClickTab,
        handleCreateOrgaoVinculado,
        handleUpdateOrgao,
        handleUpdateOrgaoVinculado,
        handleDeleteOrgaoVinculado,
        requestUpdateSistemaContabil,
        handleUpdateSistemaContabil,
        handleCreateConfiguracaoSistemaContabil,
        handleUpdateConfiguracaoSistemaContabil,
        handleDeleteConfiguracaoSistemaContabil,
        handleConfiguracaoSistemaContabilChange,
        handleUpdateTipoEmpenhosERestos,
        handleTipoEmpenhosERestosChange,
        handleUpdateSistemaContabilIntegrado,
        handleSistemaContabilIntegradoChange,
        handleGetOrdenacaoFontes,
        handleGetFontesOrfas,
        handleGetContasEPlanilha,
        handleUpdateFonteFavorita,
        handleUpdateCategoriaFonte,
        handleUpdateDescricaoFonte,
        handleCreateFonte,
        handleUpdateConta,
        handleCreateConta,
        handleDeleteConta,
        handleEncerrarConta,
        handleDeleteFonte,
        handleUpdateContasFontes,
        handleGetAutorizacoesBancoDoBrasil,
        handleGetContasComErro,
        handleGetContasInativas,
        handleCreateIdAplicacao,
        handleUpdateIdAplicacao,
        handleCreateCredenciais,
        handleUpdateCredenciais,
        handleDeleteAutorizacao,
        handleGetBancosVanBancaria,
        handleUpdateNumeroRequerimentoVan,
        handleCreateCredenciaisVan,
        handleUpdateCredenciaisVan,
        handleGetDocumentoSignedUrlVan,
        handleGetUsuarios,
        handleUpdateCategoriasUsuario,
        handleGetFontes,
        handleGetOrgaosVinculados,
        handleUpdateOrdenacaoFontes,
    }
}
